import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { ICustomerOrderReportRes } from '@/interfaces/report';
import { formatDate } from '@/utils/dataUtils';

interface IProps {
  data: ICustomerOrderReportRes[];
  startDate: string;
  endDate: string;
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CustomerOrderReport');

    // Define header row
    const headers = [
      'IV NUMBER',
      'PO NUMBER',
      'PRODUCT',
      'QUANTITY',
      'DELIVERY DATE',
      'FEEDMILL',
      'PLATE NUMBER',
    ];

    worksheet.getRow(1).values = headers;

    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6251b' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    data.forEach(item => {
      worksheet.addRow([
        item.ivNo,
        item.poNo,
        item.productName,
        item.quantity,
        formatDate(item.orderDate),
        item.shippingAddressName,
        item.numberPlate,
      ]);
    });

    // Auto width for columns
    worksheet.columns = headers.map((header, index) => ({
      header,
      key: `col${index}`,
      width: Math.max(header.length, 20) + 2, // Add padding
    }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `customer-order-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
